import Vue from 'vue';
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue';
import router from './router';
import store from './store';
import App from './App.vue';
import i18n from '@/libs/i18n';
import './global-components';
import '@/libs/portal-vue';
import '@/libs/toastification';

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// import core styles
import '@core/scss/core.scss';

// import assets styles
import '@/assets/scss/style.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
